import { RangeInput, Box, Text } from "grommet";

const Slider = ({
  parameter,
  setParameter,
  minValue,
  maxValue,
  stepValue,
  controlName,
  compact = false,
  scale = "linear",
  exponent = 2,
}) => {
  const isExponential = scale === "exponential";
  const range = maxValue - minValue;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const getPrecision = (value) => {
    const decimalPart = value.toString().split(".")[1];
    return decimalPart ? decimalPart.length : 0;
  };

  const roundToStep = (value) => {
    if (!stepValue) {
      return value;
    }

    const steppedValue =
      minValue + Math.round((value - minValue) / stepValue) * stepValue;

    return Number(steppedValue.toFixed(getPrecision(stepValue)));
  };

  const valueToSliderPosition = (value) => {
    if (!isExponential || range <= 0) {
      return value;
    }

    const normalizedValue = clamp((value - minValue) / range, 0, 1);
    return Math.pow(normalizedValue, 1 / exponent);
  };

  const sliderPositionToValue = (value) => {
    if (!isExponential || range <= 0) {
      return value;
    }

    const normalizedPosition = clamp(value, 0, 1);
    return minValue + Math.pow(normalizedPosition, exponent) * range;
  };

  const handleSliderChange = (event) => {
    const inputValue = parseFloat(event.target.value);
    const nextValue = roundToStep(sliderPositionToValue(inputValue));
    setParameter(clamp(nextValue, minValue, maxValue));
  };

  return (
    <Box
      align="center"
      className={compact ? "slider-row slider-row-compact" : "slider-row"}
      direction="row"
      margin={{ bottom: "xxsmall", top: "xsmall" }}
      responsive={false}
    >
      <Text className="slider-label" margin={{ right: "xsmall" }} size="xsmall">
        {controlName}
      </Text>
      <div className="parameter">
        <Text margin={{ right: "xsmall" }} size="xsmall" weight={300}>
          {parameter}
        </Text>
      </div>

      <RangeInput
        className="slider-input"
        string={"control"}
        title={`Set ${controlName}`}
        min={isExponential ? 0 : minValue}
        max={isExponential ? 1 : maxValue}
        step={isExponential ? 0.001 : stepValue}
        value={valueToSliderPosition(parameter)}
        color={"#FFF"}
        onChange={handleSliderChange}
        margin={{ right: "xsmall" }}
      />
      <Text
        className="slider-max"
        margin={{ left: "xsmall" }}
        size="xsmall"
        weight={300}
      >
        {maxValue}
      </Text>
    </Box>
  );
};

export default Slider;
